<template>
	<ul id="gender">
		<label class="label_radio">{{getLabel(params.label)}}  <span v-if="params.compulsory" class="star">*</span>:</label>
		<div class="template_input">
			<li v-for="(_value, key) in params.options">
				<input type="radio" v-bind:id="params.name+'_'+key" v-bind:value="_value.value" v-bind:name="params.name" v-model="answer">
				<label v-bind:for="params.name+'_'+key" v-on:touchstart="forceFocus" v-on:touchend="forceFocus">{{getLabel(_value.label)}}</label>
			</li>
		</div>
	</ul>
</template>
<script>

import componentTools from '@/libs/componentTools.js';
import lib from '@/libs/main.js';

export default {
	name: 'radio_input',
	data() {
		return {
			answer : false,
		}
	},
	props : ['params', 'oldValue', 'lang'],
	computed : {
	},
	methods : {
		validate : function(v) {
			return typeof(v) == 'string' && v.length;
		},
		notifyUpdate : function(val) {
			this.$emit('validateField', this.params.name, val);
		},
		getLabel : componentTools.getLabel,
		forceFocus : function(event){
			let label = event.target;
			if(!label || !label.htmlFor) return;
			let input = document.getElementById(label.htmlFor);
			if(!input || !input.click) return;
			input.click();
		}
	},
	watch: {
		answer : function(val){
			if(this.validate(val)) this.notifyUpdate(val);
			else this.notifyUpdate();
		},
		oldValue : function(val){
			if(!val) this.answer = false;
		}
	},
	mounted : function(){
		if(this.oldValue && this.oldValue.length) this.answer = this.oldValue;
	},
};
</script>



// WEBPACK FOOTER //
// src/components/candidate_forms/radio_input.vue